// Authors: people who author articles or are associated with the business.
// Each entry produces a Person schema fragment for BlogPosting.author and
// for any author-byline UI. Update the operator-supplied info (T015).

const authors = {
  "فريق ونش الإنقاذ": {
    name: "فريق ونش الإنقاذ",
    slug: "winch-team",
    jobTitle: "فريق خدمة العملاء والإنقاذ",
    bio: "فريق خدمة العملاء في ونش انقاذ محمد بحر، يجيب على طلبات السحب والإنقاذ على مدار الساعة.",
  },
  "مهندس أحمد محمود": {
    name: "مهندس أحمد محمود",
    slug: "ahmed-mahmoud",
    jobTitle: "كبير الفنيين",
    bio: "كبير الفنيين في ونش انقاذ محمد بحر، خبرة 15 سنة في مجال إنقاذ ورفع السيارات.",
  },
  "م. محمد علي": {
    name: "م. محمد علي",
    slug: "mohamed-ali",
    jobTitle: "مهندس ميكانيكا",
    bio: "مهندس ميكانيكا متخصص في معدات الإنقاذ، يعمل على تطوير أسطول ونش انقاذ محمد بحر.",
  },
  "خبير السلامة على الطرق": {
    name: "خبير السلامة على الطرق",
    slug: "road-safety-expert",
    jobTitle: "مستشار السلامة المرورية",
    bio: "مستشار في السلامة المرورية، يكتب عن إجراءات السلامة عند تعطل السيارة على الطرق السريعة.",
  },
};

export function getAuthor(name) {
  if (!name) return authors["فريق ونش الإنقاذ"];
  return authors[name] || {
    name,
    slug: encodeURIComponent(name),
    jobTitle: "فريق ونش انقاذ محمد بحر",
    bio: "",
  };
}

export function authorPersonSchema(name) {
  const a = getAuthor(name);
  return {
    "@type": "Person",
    name: a.name,
    jobTitle: a.jobTitle,
    worksFor: { "@type": "Organization", name: "ونش انقاذ سيارات محمد بحر", "@id": "https://winchmohamedbahr.com/#business" },
  };
}

export default authors;
